import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-04/lesson-13/task-02";
import config from "appConfig";

const task: Slide = {
  titleHtml:
    "The datasheet of an  electrodynamic geophone is given below. Calculate the value of the<br>equivalent compliance of the suspensions.",
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [5, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/13/task/task-2.svg`,
                },
              },
              styles: {
                padding: "5%",
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task02.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
